/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { PermitDetails } from "./permit-details";
import { PermitList } from "./permit-list";
import { PublicSearch } from "cms/components/permit-display/public-search";
import { useFetchPermit } from "cms/hooks/use-fetch-permit";

const PermitDisplayComponent = (props) => {
    const { component = {} } = props || {};
    const [selectedPermit, setSelectedPermit] = useState(null);
    const [rawQueryValue, setRawQueryValue] = useState("");
    const [queryValue, setQueryValue] = useState();
    const [queryType, setQueryType] = useState();
    const {
        isLoading,
        permits: publicPermits,
        fetchPrePermitQuery,
        fetchPermitByQuery,
        fetchDefaultPublicPermits,
    } = useFetchPermit();
    const [permits, setPermits] = useState(publicPermits);
    const publicPermitSearchHandler = async () => {
        // Fetch Permits by query

        if (!queryValue && !rawQueryValue) {
            return fetchDefaultPublicPermits();
        }
        const payload = {
            type: queryType,
            value: queryValue || rawQueryValue,
        };
        await fetchPermitByQuery(payload);
    };

    const buildPermitQuery = async (value) => {
        const { data, type } = await fetchPrePermitQuery({ value });
        if (type === "permit_number") {
            setRawQueryValue(value);
        }
        setQueryType(type);
        return data || [];
    };

    const onSelectOption = (data) => {
        setQueryValue(data);
    };

    const resetFetch = async () => {
        setQueryValue();
        setRawQueryValue();
        fetchDefaultPublicPermits();
    };

    const goBackHandler = () => {
        setSelectedPermit(null);
    };

    useEffect(() => {
        setPermits(publicPermits);
    }, [publicPermits]);

    return (
        <div className="permit-display-container">
            {!!selectedPermit && <PermitDetails permit={selectedPermit} goBackHandler={goBackHandler} />}
            {!selectedPermit && (
                <PermitList
                    isLoading={isLoading}
                    component={component}
                    permits={permits}
                    setSelectedPermit={setSelectedPermit}
                    onChangeHandler={buildPermitQuery}
                    onSearchHandler={publicPermitSearchHandler}
                    onSelectOption={onSelectOption}
                    resetFetch={resetFetch}
                    queryValue={queryValue?.label || ""}
                    SearchFilterComp={PublicSearch}
                />
            )}
        </div>
    );
};

PermitDisplayComponent.displayName = "PermitDisplayComponent";
export { PermitDisplayComponent };
